/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 金刚区列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  module: "TICKET" | "MALL",

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cms.VajraDistrictDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/${module}/vajra-districts`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
